import { render, staticRenderFns } from "./yang.vue?vue&type=template&id=4e064843&scoped=true&"
import script from "./yang.vue?vue&type=script&lang=js&"
export * from "./yang.vue?vue&type=script&lang=js&"
import style0 from "./yang.vue?vue&type=style&index=0&id=4e064843&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e064843",
  null
  
)

export default component.exports